import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { footer, videos } from "../mock";

const videoHref = {};
videos.items.forEach((v) => {
  videoHref[v.label] = v.vimeoId ? `https://vimeo.com/${v.vimeoId}${v.vimeoHash ? `/${v.vimeoHash}` : ""}` : null;
});

const Footer = () => {
  return (
    <footer className="text-white" style={{ backgroundColor: "#0f2540" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <Logo src="/braveme-logo-footer.png" imgClassName="h-16 md:h-20" />
            <p className="mt-4 text-white/70 font-semibold max-w-xs">{footer.tagline}</p>
          </div>

          {footer.columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-lg mb-4" style={{ color: "#F1C91F" }}>
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => {
                  const isVideo = col.title === "Videos";
                  const isPrivacy = l === "Privacy Policy";
                  const vUrl = isVideo ? videoHref[l] : null;
                  const external = Boolean(vUrl);
                  return (
                    <li key={l}>
                      {isPrivacy ? (
                        <Link
                          to="/privacy"
                          className="text-white/70 hover:text-white transition-colors font-medium"
                          data-testid="footer-privacy-link"
                        >
                          {l}
                        </Link>
                      ) : (
                        <a
                          href={external ? vUrl : isVideo ? "#videos" : "#"}
                          target={external ? "_blank" : undefined}
                          rel={external ? "noopener noreferrer" : undefined}
                          className="text-white/70 hover:text-white transition-colors font-medium"
                        >
                          {l}
                        </a>
                      )}
                      {isVideo && !external && (
                        <span className="block text-[11px] font-bold uppercase tracking-wide mt-0.5" style={{ color: "#FF6C10" }}>Coming Soon</span>
                      )}
                      {l === "Courage Canyon Outfitters" && (
                        <span className="block text-[11px] font-bold uppercase tracking-wide mt-0.5" style={{ color: "#FF6C10" }}>Coming Soon</span>
                      )}
                    </li>
                  );
                })}
                {col.contact && (
                  <>
                    <li>
                      <a href={`mailto:${col.contact.email}`} className="text-white/70 hover:text-white transition-colors font-medium break-all">
                        {col.contact.email}
                      </a>
                    </li>
                    <li>
                      <a href={`tel:+1${col.contact.phone.replace(/[^0-9]/g, "")}`} className="text-white/70 hover:text-white transition-colors font-medium">
                        {col.contact.phone}
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-sm">{footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
